import React, { useState, useEffect, useRef } from 'react';
import '../../styles/geminiLoading.css';

const GeminiLoadingScreen = ({ userPrompt = null, hideText = false, bridgeMessage = '' }) => {
    const [typedText, setTypedText] = useState('');
    const [isTyping, setIsTyping] = useState(false);
    const textBlockRef = useRef(null);

    useEffect(() => {
        // Pulisci il bridgeMessage da eventuali JSON
        let cleanBridgeMessage = bridgeMessage || '';
        
        // Rimuovi JSON se presente (sia come oggetto che come stringa)
        if (cleanBridgeMessage.trim().startsWith('{')) {
            try {
                // Trova la fine del JSON
                let jsonEnd = -1;
                let braceCount = 0;
                for (let i = 0; i < cleanBridgeMessage.length; i++) {
                    if (cleanBridgeMessage[i] === '{') braceCount++;
                    if (cleanBridgeMessage[i] === '}') {
                        braceCount--;
                        if (braceCount === 0) {
                            jsonEnd = i;
                            break;
                        }
                    }
                }
                
                if (jsonEnd > 0) {
                    const jsonStr = cleanBridgeMessage.substring(0, jsonEnd + 1);
                    const json = JSON.parse(jsonStr);
                    // Se è un JSON di validazione, rimuovilo e prendi solo il testo dopo
                    if (json.valid === false || json.valid === true) {
                        cleanBridgeMessage = cleanBridgeMessage.substring(jsonEnd + 1).trim();
                        // Rimuovi anche eventuali newline o spazi multipli all'inizio
                        cleanBridgeMessage = cleanBridgeMessage.replace(/^[\n\r\s]+/, '');
                    }
                }
            } catch (e) {
                // Non è JSON valido, continua
            }
        }
        
        // Rimuovi anche JSON che potrebbe essere nel mezzo o alla fine del testo
        cleanBridgeMessage = cleanBridgeMessage.replace(/\{\s*"valid"\s*:\s*(true|false)\s*\}/g, '').trim();
        cleanBridgeMessage = cleanBridgeMessage.replace(/\{\s*"valid"\s*:\s*"(true|false)"\s*\}/g, '').trim();
        cleanBridgeMessage = cleanBridgeMessage.replace(/```json\s*\{\s*"valid"\s*:\s*(true|false)\s*\}\s*```/gi, '').trim();
        cleanBridgeMessage = cleanBridgeMessage.replace(/```\s*\{\s*"valid"\s*:\s*(true|false)\s*\}\s*```/gi, '').trim();
        
        const sanitizedMessage = userPrompt ? cleanBridgeMessage.replace(/\r\n/g, '\n').trim() : '';
        let isActive = true;
        let typingTimeout = null;

        if (!sanitizedMessage) {
            setTypedText('');
            setIsTyping(false);
            return () => {
                isActive = false;
                if (typingTimeout) clearTimeout(typingTimeout);
            };
        }

        setTypedText('');
        setIsTyping(true);

        let index = 0;

        const scheduleNext = (delay) => {
            typingTimeout = setTimeout(typeNext, delay);
        };

        const typeNext = () => {
            if (!isActive) {
                return;
            }

            index += 1;
            setTypedText(sanitizedMessage.slice(0, index));

            if (index >= sanitizedMessage.length) {
                if (isActive) {
                    setIsTyping(false);
                }
                return;
            }

            const currentChar = sanitizedMessage.charAt(index - 1);
            let delay = 42;
            if (currentChar === '.') {
                delay = 260;
            } else if (currentChar === ',') {
                delay = 150;
            } else if (currentChar === '\n') {
                delay = 220;
            } else if (currentChar === ' ') {
                delay = 60;
            }

            scheduleNext(delay);
        };

        scheduleNext(60);

        return () => {
            isActive = false;
            if (typingTimeout) {
                clearTimeout(typingTimeout);
            }
        };
    }, [bridgeMessage, userPrompt]);

    // Auto-scroll in basso quando il testo viene scritto
    useEffect(() => {
        if (textBlockRef.current && typedText) {
            textBlockRef.current.scrollTop = textBlockRef.current.scrollHeight;
        }
    }, [typedText]);

    return (
        <div className="gemini-loading-screen gemini-loading-container">
            <div className="gemini-loading-content">
                <div className="loading-artist-image-container">
                    <div className="loading-artist-image-wrapper">
                        <img src={`${process.env.PUBLIC_URL}/img/penso.jpg`} alt="Thinking" className="loading-artist-image" />
                        <div className="spinning-border"></div>
                    </div>
                </div>

                {!hideText && userPrompt && (
                    <div className="gemini-loading-text-block" ref={textBlockRef}>
                        <p className="typing-text">
                            {typedText}
                            {isTyping && <span className="typing-cursor">|</span>}
                        </p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default GeminiLoadingScreen;

